export default __webpack_public_path__ + "static/media/star.bb57125f.svg";